// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import tool02Icon from "@/assets/icons/tool-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Tool02IconProps = Omit<IconProps, "name">;

export function Tool02Icon(props: Tool02IconProps): React.ReactNode {
  return <Icon name={tool02Icon} {...props} />;
}
